"use client";

import { useEffect } from "react";

// This is a hack to be able to scroll to a # position in the url. Need it because emotion is causing hydration issues
export function ScrollRestoration() {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      requestAnimationFrame(() => {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      });
    }
  }, []);

  return null;
}
